import { useContext, useEffect, useState } from 'react';
import { BreadcrumbContext } from 'shared/context/Breadcrumb';

/**
 * Overrides the global header's title/subtitle and rounds it while the page is mounted.
 * Returns the header's action slot so the page can portal its Create button into it.
 */
export const useAdsPageHeader = (title: string, subtitle: string) => {
  const { setTitleOverride, setSubtitleOverride, setRoundedHeader } = useContext(BreadcrumbContext);
  const [headerActionEl, setHeaderActionEl] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setTitleOverride(title);
    setSubtitleOverride(subtitle);
    setRoundedHeader(true);
    setHeaderActionEl(document.getElementById('header-action'));
    return () => {
      setTitleOverride(undefined);
      setSubtitleOverride(undefined);
      setRoundedHeader(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return headerActionEl;
};
